import { useLocation, useNavigate } from 'react-router-dom'
import { retrunAssets } from '../utils/getAssets'
import useFetch from '../utils/useFetch'
import { DecodeHtml } from '../utils/decodeHtml'

import { useEffect, useMemo, useState } from 'react'
import TabsPage from './tabsPage'

export const Container = ({ children }) => {
  return (
    <div className='flex justify-center p-4 md:py-8 w-full'>
      <div className='flex flex-col gap-5 lg:px-16  w-full'>{children}</div>
    </div>
  )
}

const GlobalExchange = () => {
  const base = 'student-hub/'
  const navigate = useNavigate()

  const state1 = useFetch(base + 'about-360-gem/')
  const state2 = useFetch(base + 'upcoming-360-gem/')
  const state3 = useFetch(base + 'apply-360-gem/')
  const state4 = useFetch(base + 'contact-us-360-gem/')

  const data1 = state1?.properties
  const data2 = state2?.properties
  const data3 = state3?.properties
  const data4 = state4?.properties
  const location = useLocation()
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  )
  const defaultActiveTab = parseInt(queryParams.get('tab')) || 0
  const [activeTab, setActiveTab] = useState(defaultActiveTab)

  useEffect(() => {
    if (queryParams.get('tab') == '4' || queryParams.get('tab') == '5') {
      setActiveTab(0)
      queryParams.set('tab', 0)
      navigate({ search: queryParams.toString() })
    }
    if (activeTab == 4) {
      navigate('/international-office')
    }
    if (activeTab == 5) {
      navigate('/training-services/edu-tourism')
    }
  }, [activeTab])

  useEffect(() => {
    const activeTabFromQuery = parseInt(queryParams.get('tab')) || 0
    setActiveTab(activeTabFromQuery)
  }, [queryParams])

  // const handleTabClick = index => {
  //   setActiveTab(index)
  //   queryParams.set('tab', index)
  //   navigate({ search: queryParams.toString() })
  // }

  const title = data1?.title
  const bg =
    data1?.backgroundImage != null
      ? retrunAssets(data1?.backgroundImage[0]?.url)
      : ''
  // const imageCarousel = data1?.imageCarousel?.map(item => retrunAssets(item?.url));
  const headers = [
    'About 360 GEM',
    'Upcoming 360 GEM',
    'Apply 360 GEM',
    'Contact Us',
    'International Office',
    'Edu Tourism'
  ]

  const data = [
    {
      header: headers[0],
      content: (
        <Container>{DecodeHtml({ html: data1?.contents?.markup })}</Container>
      )
    },
    {
      header: headers[1],
      content: (
        <Container>{DecodeHtml({ html: data2?.contents?.markup })}</Container>
      )
    },
    {
      header: headers[2],

      content: (
        <Container>{DecodeHtml({ html: data3?.contents?.markup })}</Container>
      )
    },
    {
      header: headers[3],
      content: (
        <Container>{DecodeHtml({ html: data4?.contents?.markup })}</Container>
      )
    },
    {
      header: headers[4],
      content: null
    },
    {
      header: headers[5],
      content: null
    }
  ]

  return (
    // <AnimatedPage>
    //   <Banner text={title} bg={bg} />
    //   <div className="flex justify-center w-full p-8 md:p-12">
    //     <div className="w-full lg:max-w-7xl">
    //       <div className="w-full relative  flex flex-col ">
    //         <div className="flex w-full bg-cover bg-no-repeat bg-center pt-4 rounded-lg" style={{ backgroundImage: `url(${bg})` }} >

    //           <TabHeaders headers={data?.map(item => item.header)} activeTab={activeTab} handleTabClick={handleTabClick} />
    //         </div>
    //         <Contents contents={data?.map(tab => tab.content)} activeTab={activeTab} />
    //       </div>

    //     </div>

    //   </div>
    // </AnimatedPage>
    <TabsPage title={title} bg={bg} tabs={data} />
  )
}

export default GlobalExchange
